import { VideoReelModel } from "@/models";
import { ActionType, ReducerAction, ReducerType, VideoReelsDefault } from "./const";

export const initialState = {
  data: VideoReelsDefault,
  filters: {
    limit: 5,
    offset: 0,
    sort_by: 'created_at',
    sort: 'desc',
  }
};

export const reducer = (state: ReducerType, action: ReducerAction): ReducerType => {
  switch (action.type) {
    case ActionType.OnLoadMore:
      return {
        ...state,
        filters: {
          ...state.filters,
          limit: action.payload.limit || state.filters.limit,
          offset: action.payload.offset
        },
      };
    case ActionType.SetData:
      return {
        ...state,
        data: action.payload,
      }
    case ActionType.AppendData:
      return {
        ...state,
        data: {
          edges: [...state.data.edges, ...action.payload.edges],
          count: action.payload.count
        },
      }
    case ActionType.UpdateVideo:
      return {
        ...state,
        data: {
          ...state.data,
          edges: state.data.edges.map((video: VideoReelModel) => {
            if (video.id === action.payload.id) {
              return action.payload;
            }
            return video;
          })
        }
      }
    case ActionType.ToggleLike:
      return {
        ...state,
        data: {
          ...state.data,
          edges: state.data.edges.map((video: VideoReelModel) => {
            if (video.id === action.payload.id) {
              return {
                ...video,
                is_liked: action.payload.is_liked,
                like_count: action.payload.like_count,
              };
            }
            return video;
          })
        }
      }
    default:
      return { ...initialState };
  }
}